import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';

const HocPopupComponent = props => {
  const {
    children = '',
    closeClick = () => {},
    showCloseIcon = false,
    customClassName = '',
    customClassNameOnly = '',
    allowMaskClick = true,
    wrapperRef,
  } = props;

  const cancelClick = (e, isMaskClick = false) => {
    if (e) e.preventDefault();
    if (isMaskClick) {
      if (allowMaskClick) closeClick();
    } else {
      closeClick();
    }
  };

  return (
    <>
      <div
        className={`common-popup ${customClassName} ${customClassNameOnly}`}
        ref={wrapperRef}
      >
        <div className="popup-wrap">
          {showCloseIcon && (
            <div
              className="popup-close"
              title="Click here to close"
              onClick={e => cancelClick(e)}
            >
              <CloseIcon />
            </div>
          )}

          <div className="popup-content-wrap">{children}</div>
        </div>
      </div>
      <div
        className={`common-popup-mask ${
          customClassName !== '' ? `${customClassName}-mask` : ''
        }`}
        onClick={e => cancelClick(e, true)}
      />
    </>
  );
};

export { HocPopupComponent };
export default HocPopupComponent;
